module.exports = __webpack_public_path__ + "static/media/logout_darkbleu.f8abb37d.svg";